import type { InternalHost } from '../host';
import { useHost } from './use-host';

export function useLoginAppUrl(): string {
  const host = useHost<InternalHost>();

  return host.config.loginAppUrl;
}
